import React, { Component } from 'react';
import { Card, DatePicker,LocaleProvider,locales,InputNumber,Form,Table,Button,message} from 'antd';
import moment from 'moment';
import AutoScale from 'react-auto-scale';
import { Link } from 'react-router/lib';
import {connect} from 'react-redux';
import {bookSelect} from './reducers'
import {browserHistory} from 'react-router/lib';

const RangePicker = DatePicker.RangePicker;
const FormItem = Form.Item;

class BookNow extends Component{
  constructor(props){
    super(props);
    this.state={
      adult:1,
      chlid:0,
      price:this.props.price,
      cost_a:0,
      cost_c:0,
      cost:this.props.price,
      date:[],
    };


  }
  onBook(){

    if(this.state.date.length==0){

      message.error('Please select a date range')
    }
    else{

      const data ={
        adult:this.state.adult,
        child:this.state.child,
        price:this.state.price,
        cost:this.state.cost,
        date:this.state.date,
        title:this.props.title
      }



      this.props.onBook(data);
      browserHistory.push('/details')

    }

    //console.log("data",data);
  }

  adultChange(value){
    const cost = this.state.price*value;
    this.setState({adult:value,cost_a:cost,cost:cost+this.state.cost_c});


  }
  childChange(value){
    const cost = (this.state.price*value)/2;
    this.setState({child:value,cost_c:cost,cost:this.state.cost_a+cost});
  }

  onChange(date, dateString) {
    this.setState({date:dateString});
  console.log('date', dateString);
}

  render(){
    console.log("price",this.state.price);
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const columns = [{
      dataIndex: 'name',
    }, {
      className: 'column-money',
      dataIndex: 'money',
    }];
    const data = [{
        key: '1',
        name: 'Adults',
        money: this.state.adult,

      }, {
        key: '2',
        name: 'Children',
        money: this.state.child,

      }, {
        key: '3',
        name: 'Total Amount',
        money: this.state.cost,

      }];

    return(
      <div style={{width:300,height:300}}>
        <AutoScale maxScale={2}>
          <Card style={{width:300,margin:'auto'}}>

            <Form>
              <FormItem>
                <div style={{background:'#2d2d2d',width:'100%',textAlign:'center'}}>
                  <h2 style={{color:'white'}}>-BOOKING-</h2>
                </div>
              </FormItem>
              <FormItem
                   >
                   <RangePicker locale={obj} onChange={this.onChange.bind(this)} />
             </FormItem>
             <FormItem
                  {...formItemLayout}
                  label="Adults">
                  <InputNumber min={1}  defaultValue={1} onChange={this.adultChange.bind(this)} />

            </FormItem>
            <FormItem
              {...formItemLayout}

              label="Children"
              >
                <InputNumber min={0}  defaultValue={0} onChange={this.childChange.bind(this)}/>
            </FormItem>
            <FormItem

              >
              <Table
                showHeader={false}
                columns={columns}
               dataSource={data}
               pagination={false}

             />
            </FormItem >
            <FormItem >
              <Button type="primary" size="large" style={{width:'100%'}} onClick={this.onBook.bind(this)}>Book Now</Button>

            </FormItem>
            <FormItem>
              <Button  style={{width:'100%'}} size="small">Add to Wish List</Button>
            </FormItem>



            </Form>
            <br />



          </Card>
        </AutoScale>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch)=>(
  {
    onBook:(data)=>{
      dispatch(bookSelect(data));
    }
  }
)


var obj={
  "lang": {
    "placeholder": "Select date",
    "rangePlaceholder": [
      "Start date",
      "End date"
    ],

    "today": "Today",
    "now": "Now",
    "backToToday": "Back to today",
    "ok": "Ok",
    "clear": "Clear",
    "month": "Month",
    "year": "Year",
    "timeSelect": "Select time",
    "dateSelect": "Select date",
    "monthSelect": "Choose a month",
    "yearSelect": "Choose a year",
    "decadeSelect": "Choose a decade",
    "yearFormat": "YYYY",
    "dateFormat": "M/D/YYYY",
    "dayFormat": "D",
    "dateTimeFormat": "M/D/YYYY HH:mm:ss",
    "monthFormat": "MMMM",
    "monthBeforeYear": true,
    "previousMonth": "Previous month (PageUp)",
    "nextMonth": "Next month (PageDown)",
    "previousYear": "Last year (Control + left)",
    "nextYear": "Next year (Control + right)",
    "previousDecade": "Last decade",
    "nextDecade": "Next decade",
    "previousCentury": "Last century",
    "nextCentury": "Next century"
  },
  "timePickerLocale": {
    "placeholder": "Select time"
  }
}
export default connect(null,mapDispatchToProps)(BookNow)



// WEBPACK FOOTER //
// ./src/BookNow.js